<template>
  <div class="page">
    <div class="group">
    
      <div class="search">
        <img src="../../assets/new/Frame@2x.png" alt="" />
        <input
          ref="inputName"
          type="text"
          placeholder="搜索您想要的关键词"
          class="search-input"
          v-model="selectValue"
          @keyup.enter="handleSearch"
        />
      </div>
      <!-- 历史搜索 -->
      <div class="history">
        <div class="text">
          <span class="text_1">历史搜索</span>
          <img src="../../assets/new/del.png" @click="clearHistory" />
        </div>
        <div
          v-if="historySearch.length < 1"
          style="color: #999; text-align: center; margin-top: 40px"
        >
          暂无历史数据
        </div>
        <div class="group_1" v-if="historySearch.length">
          <span
            class="box"
            v-for="(item, index) in historySearch"
            :key="index"
            @click="handleHistoryClick(item)"
          >
            {{ item }}
          </span>
        </div>
      </div>
      <!-- 热门搜索 -->
      <!-- <div class="group_2">
				<div class="text">
					<span class="text_1">热门搜索</span>
				</div>
				<div class="group_3" v-if="hotSearch.length">
					<span
						class="box"
						v-for="(item, index) in hotSearch"
						:key="index"
					>
						{{ item }}
					</span>
				</div>
			</div> -->
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      selectValue: "", // 输入框值
      hotSearch: [], // 热门搜索
      historySearch: [], // 历史搜索
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.inputName.focus();
    });
    this.historySearch =
      JSON.parse(localStorage.getItem("historySearch")) || [];
  },
  methods: {
    // 返回上一页
    goBack() {
      this.$router.go(-1);
    },
    handleSearch() {
      if (this.selectValue.trim()) {
        this.addToHistory(this.selectValue);
        this.$router.replace({
          path: "/selectPage",
          query: { keyword: this.selectValue },
        });
        this.selectValue = "";
      }
    },
    // 添加到历史记录
    addToHistory(value) {
      if (this.historySearch.length >= 5) {
      this.historySearch.pop(); // 如果超过5个，删除最后一个
    }
    this.historySearch.unshift(value); // 将新的或已存在的值加到最前面
    localStorage.setItem("historySearch", JSON.stringify(this.historySearch));
    },
    // 删除所有历史记录
    clearHistory() {
      this.historySearch = [];
      localStorage.removeItem("historySearch");
    },
    // 点击历史记录跳转页面
    handleHistoryClick(item) {
       const index = this.historySearch.indexOf(item);
    if (index > -1) {
      this.historySearch.splice(index, 1);
    }
    this.addToHistory(item); // 添加到最前面
    // 导航到搜索结果页
    this.$router.push({ path: "/selectPage", query: { keyword: item } });
    },
  },
};
</script>

<style lang="less" scoped>
.page {
  background-color: #fff;
  height: 100vh;
}

.title {
  display: flex;
  justify-content: space-between;
}

.title img {
  width: 18px;
  height: 18px;
}

.ti {
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 17px;
  color: #333333;
}

.search-input {
  border: 0;
  width: 100%;
  height: 42px;
  background: #f6f8fa;
  border-radius: 8px 8px 8px 8px;
  padding-left: 40px;
  font-size: 14px;
  color: #999;
}

.search {
  // margin-top: 16px;
  position: relative;
  background-color: #fff;
  width: 100%;
  height: 40px;
}

.search-input::placeholder {
  color: #999;
}

.search img {
  width: 14px;
  height: 14px;
  position: absolute;
  top: 53%;
  left: 22px;
  transform: translateY(-50%);
}

.history {
  margin-top: 29px;
}

.history .text {
  display: flex;
  justify-content: space-between;
}

.text_1 {
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 16px;
  color: #000000;
}

.history img {
  width: 20px;
  height: 20px;
}

.group_1 {
  height: auto;
}
.group{
  padding: 0 15px;
}

.group_1 .box {
  height: 32px;
  line-height: 32px;
  display: inline-block;
  background: #f6f8fa;
  margin-top: 12px;
  padding: 0 18px;
  margin-right: 12px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 15px;
  color: #666666;
  border-radius: 4px 4px 4px 4px;
}

.group_2 {
  margin-top: 34px;
}

.group_2 .text {
  display: flex;
  justify-content: space-between;
}

.group_3 {
  height: auto;
}

.group_3 .box {
  height: 64rpx;
  line-height: 64rpx;
  margin-top: 24rpx;
  margin-right: 24rpx;
  display: inline-block;
  background: #f6f8fa;
  padding: 0 36rpx;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 30rpx;
  color: #666666;
  border-radius: 8rpx 8rpx 8rpx 8rpx;
}
</style>
